const opportunities = document.querySelectorAll("#opportunityContainer li");
const opportunityTeamSelect = document.getElementById("opportunityTeam");
const opportunityLocationSelect = document.getElementById("opportunityLocation");
const remotePreferenceSelect = document.getElementById("remotePreference");

const filterOpportunities = () => {
  const teamFilter = opportunityTeamSelect.value;
  const locationFilter = opportunityLocationSelect.value;
  const remoteFilter = remotePreferenceSelect.value;

  console.info(`🔍 Filtering ${opportunities.length} Job Opportunities | Team '${teamFilter || "Any"}' - Location '${locationFilter || "Any"}' - Remote Preference '${remoteFilter || "Any"}'`);

  for (let i = 0; i < opportunities.length; i++) {
    const opportunity = opportunities[i];
    if (!opportunity.dataset) console.error("Missing dataset on opportunity", opportunity);

    // 1. Reset all opportunities to visible
    opportunity.classList.remove("hidden");

    // 2. If no filters are selected, return early
    if (!teamFilter && !locationFilter && (!remoteFilter || remoteFilter === "Remote or On-Site")) continue;

    // 2. Filter out location mismatches
    if (locationFilter) {
      const officeState = opportunity.dataset.state || "";
      const requiredStates = JSON.parse(opportunity.dataset.states || "[]");

      const passesLocationFilter = requiredStates.includes(locationFilter) || officeState === locationFilter;

      if (!passesLocationFilter) {
        opportunity.classList.add("hidden");
        continue;
      }
    }

    // 3. Filter out team (industry) mismatches
    const industries = JSON.parse(opportunity.dataset.industries || "[]");

    if (teamFilter && industries.length && !industries.includes(teamFilter)) {
      opportunity.classList.add("hidden");
      continue;
    }

    // 4. Filter out remote mismatches
    const remotePreference = opportunity.dataset.remote || "";

    if (remotePreference) {
      if (
        (remoteFilter === "Offers Remote" && !remotePreference.startsWith("Remote")) ||
        (remoteFilter === "On-Site Only" && !remotePreference.includes("On-Site")) ||
        (remoteFilter === "Remote Only" && !remotePreference.includes("Remote"))
      ) {
        opportunity.classList.add("hidden");
        continue;
      }
    }

    // 5. Remove Hidden
    opportunity.classList.remove("hidden");
  }
};

opportunityTeamSelect.addEventListener("change", filterOpportunities);
opportunityLocationSelect.addEventListener("change", filterOpportunities);
remotePreferenceSelect.addEventListener("change", filterOpportunities);
